module.exports = __webpack_public_path__ + "static/media/top.6981a7e9.svg";